"use strict";
/**
 * @author Hector J. Vasquez <ipi.vasquez@gmail.com>
 *
 * @licence
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const Graph_1 = require("./Graph");
exports.Graph = Graph_1.default;
const Vertex_1 = require("./Vertex");
exports.Vertex = Vertex_1.default;
const Edge_1 = require("./Edge");
exports.Edge = Edge_1.default;
const Matrix_1 = require("./Matrix");
exports.Matrix = Matrix_1.default;



//////////////////
// WEBPACK FOOTER
// ./lib/structures/index.js
// module id = 10
// module chunks = 0